export default {
  colors: {
    background: '#ffffff',
    border: '#DCD8D3',
    text: '#121212',
    primary: '#075bd6',
    primary2: '#0f56ff',
    secondary: '#e9e9e9',
    tertiary: '#f3f3f3',
    blockquote: '#FF861C',
    highlight: '#0f56ff',
    header: '#0525e2',
  },
  fonts: {
    body:
      'Lato, Montserrat, sans-serif',
    header:
      '"Bree Serif", georgia, serif',
    blockquote:
      '"Bree Serif", sans-serif',
    normalWeight: '400',
    boldWeight: '600',
  },
  sizes: {
    maxWidth: '1050px',
    maxWidthCentered: '650px',
  },
  responsive: {
    small: '35em',
    medium: '50em',
    large: '70em',
  },
}
